import { displayMessage } from '../../../services/helper';

export default (mobile_mode) => {

    return (
        [
            {
                field: 'patient_name',
                headerName: displayMessage('PATIENT_NAME'),
                width: 185,
                headerAlign: "center",
                align: 'center',
                valueGetter: function (params) {
                    return `${params?.value || ''}`
                }
            },
            {
                field: 'avg_monitory_stars',
                headerName: displayMessage('AVERAGE_STARS'),
                width: 185,
                headerAlign: "center",
                align: 'center'
            },
            {
                field: 'avg_exercise_stars',
                headerName: displayMessage('AVERAGE_EXERCISE_STARS'),
                width: 185,
                headerAlign: 'center',
                align: 'center'
            },
            {
                field: 'percent_presence',
                headerName: displayMessage('PERCENT_PRESENCE'),
                flex: 1,
                minWidth: mobile_mode ? 300 : 120,
                type: 'string',
                headerAlign: 'center',
                align: 'center',
            }
        ]
    )
}